import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Small floating badge shown on any page when the backend is running in Stripe test mode.
// Renders NOTHING in live mode so real customers never see it.
export default function StripeModeBadge() {
  const [mode, setMode] = useState(null);
  const [configured, setConfigured] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API}/stripe/mode`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        setMode(data.mode);
        setConfigured(Boolean(data.configured));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (mode !== 'test') return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 rounded-full border border-amber-400/70 bg-black/80 backdrop-blur px-3 py-1.5 shadow-lg pointer-events-none"
      data-testid="stripe-test-mode-badge"
    >
      <p className="font-manrope text-[10px] uppercase tracking-[0.25em] font-bold text-amber-300">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-amber-400 mr-2 align-middle animate-pulse" />
        Stripe {configured ? 'Test Mode' : 'Test Mode \u00b7 keys missing'}
      </p>
    </div>
  );
}
